import v4api, {v4Unscoped} from '../api/V4client';

// Stored on the account: '' = none of its own, so it inherits the one above it.
export const V4_WHITELABEL_INHERIT = '';

const sameId = (a, b) => !!a && !!b && String(a).toLowerCase() === String(b).toLowerCase();

const storedIn = (res, accountUuid) => {
  const rows = Array.isArray(res?.data) ? res.data : [];
  const row = rows.find(a => sameId(a?.id, accountUuid));
  return typeof row?.whitelabel === 'string' ? row.whitelabel : null;
};

// GET /v1/accounts/{id} only has the resolved white label, and writing that back pins an inherited one.
export async function fetchStoredV4Whitelabel(accountUuid, params) {
  let stored = storedIn(await v4api.accountsList(undefined, v4Unscoped(params)), accountUuid);
  if (stored === null) {
    stored = storedIn(await v4api.accountsList({archived: true}, v4Unscoped(params)), accountUuid);
  }
  // A guess would pin an inherited white label or clear the account's own.
  if (stored === null) throw new Error(`No stored white label found for V4 account ${accountUuid}`);
  return stored;
}
